import { render, staticRenderFns } from "./FundData.vue?vue&type=template&id=199ebd53&"
import script from "./FundData.vue?vue&type=script&lang=js&"
export * from "./FundData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports